import { memo } from "react";

import { loadLocalImage } from "../../../../../../../utils";
import {
  CustomCard,
  CustomCardHeader,
  CustomCardText,
  CustomCardTextContainer,
  CustomIcon,
} from "../styles/DesktopCardStyles";
import { CardProps } from "../types";

export const AdvantageDesktopCard = memo(
  ({ text, icon, hoverText }: CardProps) => {
    return (
      <CustomCard title={hoverText}>
        <CustomCardHeader>
          <CustomIcon src={loadLocalImage(icon, "advantages")} alt={text} loading="lazy" />
        </CustomCardHeader>

        <CustomCardTextContainer>
          <CustomCardText>{text}</CustomCardText>
        </CustomCardTextContainer>
      </CustomCard>
    );
  }
);

AdvantageDesktopCard.displayName = "AdvantageDesktopCard";